import { type Entity, stringifyEntityRef } from '@backstage/catalog-model';

import {
  DAAS_APPLICATION_SET_TYPE,
  DAAS_APPLICATION_TYPE,
  DAAS_PROJECT_TYPE,
} from '../types';

const DELETE_TEMPLATE_NAME = 'daas-delete-component';

/** A link to a scaffolder template in the default namespace. */
export const templateUrl = (templateName: string, formData?: unknown) => {
  const base = `/create/templates/default/${templateName}`;
  if (formData === undefined) {
    return base;
  }
  return `${base}?formData=${encodeURIComponent(JSON.stringify(formData))}`;
};

/**
 * The `formData` the edit template of each DaaS type expects. The keys are a
 * contract with the template YAML - see `templates/daas/<type>/edit-template.yaml`.
 */
const editFormData = (entity: Entity): Record<string, unknown> => {
  const entityRef = stringifyEntityRef(entity);

  switch (entity.spec?.type) {
    case DAAS_APPLICATION_TYPE:
      return { applicationData: { applicationRef: entityRef } };
    case DAAS_APPLICATION_SET_TYPE:
      return { applicationSetData: { applicationSetRef: entityRef } };
    case DAAS_PROJECT_TYPE:
      return { projectData: { projectRef: entityRef } };
    default:
      return {};
  }
};

/** The `edit-<type>` template, prefilled with the entity. */
export const daasEditUrl = (entity: Entity) =>
  templateUrl(`edit-${entity.spec?.type}`, editFormData(entity));

/** `daas-delete-component` takes a `DaasComponentPicker` value. */
export const daasDeleteUrl = (entity: Entity) =>
  templateUrl(DELETE_TEMPLATE_NAME, {
    component: {
      type: entity.spec?.type ?? DAAS_PROJECT_TYPE,
      entityRef: stringifyEntityRef(entity),
    },
  });
